function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { line } from 'd3-shape';
import { textPropsByEngine, axisThemePropType, labelsThemePropType } from '@nivo/core';
import { arcPropType } from './props';
import { computeRadialLabels } from './compute';
const lineGenerator = line().x(d => d.x).y(d => d.y);
export default class PieRadialLabels extends Component {
  render() {
    const _this$props = this.props,
          arcs = _this$props.arcs,
          label = _this$props.label,
          radius = _this$props.radius,
          skipAngle = _this$props.skipAngle,
          linkOffset = _this$props.linkOffset,
          linkDiagonalLength = _this$props.linkDiagonalLength,
          linkHorizontalLength = _this$props.linkHorizontalLength,
          linkStrokeWidth = _this$props.linkStrokeWidth,
          textXOffset = _this$props.textXOffset,
          textColor = _this$props.textColor,
          linkColor = _this$props.linkColor,
          theme = _this$props.theme;
    const labels = computeRadialLabels(arcs, {
      getLabel: label,
      radius,
      skipAngle,
      linkOffset,
      linkDiagonalLength,
      linkHorizontalLength,
      textXOffset
    });
    return labels.map(label => React.createElement(Fragment, {
      key: label.arc.data.id
    }, React.createElement("path", {
      d: lineGenerator(label.line),
      fill: "none",
      style: {
        fill: 'none',
        stroke: linkColor(label.arc, theme)
      },
      strokeWidth: linkStrokeWidth
    }), React.createElement("g", {
      transform: "translate(" + label.position.x + ", " + label.position.y + ")"
    }, React.createElement("text", {
      textAnchor: textPropsByEngine.svg.align[label.align],
      dominantBaseline: "central",
      style: _extends({}, theme.labels.text, {
        fill: textColor(label.arc.data, theme)
      })
    }, label.text))));
  }

}

_defineProperty(PieRadialLabels, "defaultProps", {
  skipAngle: 0,
  linkOffset: 0,
  linkDiagonalLength: 16,
  linkHorizontalLength: 24,
  linkStrokeWidth: 1,
  textXOffset: 6
});

PieRadialLabels.propTypes = process.env.NODE_ENV !== "production" ? {
  arcs: PropTypes.arrayOf(arcPropType).isRequired,
  label: PropTypes.func.isRequired,
  skipAngle: PropTypes.number.isRequired,
  radius: PropTypes.number.isRequired,
  linkOffset: PropTypes.number.isRequired,
  linkDiagonalLength: PropTypes.number.isRequired,
  linkHorizontalLength: PropTypes.number.isRequired,
  linkStrokeWidth: PropTypes.number.isRequired,
  textXOffset: PropTypes.number.isRequired,
  textColor: PropTypes.func.isRequired,
  linkColor: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    axis: axisThemePropType.isRequired,
    labels: labelsThemePropType.isRequired
  }).isRequired
} : {};